import { Checkbox, Col, Drawer, Form, Input, Row } from 'antd';
import moment from 'moment';
import React from 'react';
import DetailsButtons from '../../../../components/details-buttons';
import { DrawerWidth } from '../../../../config/dimensions';
import Routes from '../../../../config/routes';
import ReplaceStrings from '../../../../config/replaceStrings';
import { DrawerState, ModuleName } from '../../../../core/models/enum';
import { convertUTCTimeToLocal } from '../../../../helpers/DateHelper';
import { formItemLayout724 } from '../../../../helpers/FormLayoutHelper';
import { getNewRoute } from '../../../../helpers/RoutingHelper';
import { handleDeleteHelper } from '../../../../helpers/SubmitHelper';
import { TeamsClient } from '../../../../utils/api';
import TeamForm from '../../team-form';
import { Props } from './index';

interface State {
    drawerState: DrawerState;
    loading: boolean;
}

class TeamDetails extends React.PureComponent<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = {
            drawerState: props.isInitialEdit ? DrawerState.Edit : DrawerState.Closed,
            loading: true,
        };
    }

    private handleDrawerMode = (drawerState: DrawerState, id?: string): void => {
        const { history } = this.props;

        this.setState({
            drawerState,
        });

        history.push(
            getNewRoute(
                Routes.ROUTE_TEAMS,
                Routes.ROUTE_TEAMS_READ,
                Routes.ROUTE_TEAMS_EDIT,
                drawerState,
                ReplaceStrings.TEAM_ID,
                id
            )
        );
    };

    private openForm = (): void => {
        const { team } = this.props;
        this.handleDrawerMode(DrawerState.Edit, team.id.toString());
    };

    private handleDelete = (): void => {
        const { history } = this.props;

        history.push(Routes.ROUTE_TEAMS);
    };

    public render(): React.ReactElement {
        const { drawerState } = this.state;
        const { userProfile, team, refreshAfterSave } = this.props;

        return (
            <div>
                <DetailsButtons
                    userProfile={userProfile}
                    onDeleteAction={(): Promise<void> =>
                        handleDeleteHelper(
                            new TeamsClient(),
                            'Team successfully deleted.',
                            this.handleDelete,
                            team.id
                        )
                    }
                    onEditAction={this.openForm}
                    customMessage="Are you sure you want to delete this team? Deleting a team will remove it from all competitions and delete all matches it participated in."
                    moduleName={ModuleName.Teams}
                    entityId={team.id}
                />
                <Row className="details-height">
                    <Col span={12}>
                        <Form {...formItemLayout724}>
                            <Form.Item label="Name">
                                <Input readOnly value={team.name} />
                            </Form.Item>
                            <Form.Item label="Universal name">
                                <Input readOnly value={team.nameUniversal} />
                            </Form.Item>
                            <Form.Item label="Short name">
                                <Input readOnly value={team.shortName} />
                            </Form.Item>
                            <Form.Item label="Description">
                                <Input readOnly value={team.description} />
                            </Form.Item>
                            <Form.Item label="Country">
                                <Input readOnly value={team.country} />
                            </Form.Item>
                            <Form.Item label="City">
                                <Input readOnly value={team.city} />
                            </Form.Item>
                            <Form.Item label="Active from">
                                <Input
                                    readOnly
                                    value={
                                        team.activeFrom
                                            ? moment(convertUTCTimeToLocal(team.activeFrom)).format(
                                                  'DD.MM.YYYY.'
                                              )
                                            : ''
                                    }
                                />
                            </Form.Item>
                            <Form.Item label="Active to">
                                <Input
                                    readOnly
                                    value={
                                        team.activeTo
                                            ? moment(convertUTCTimeToLocal(team.activeTo)).format(
                                                  'DD.MM.YYYY.'
                                              )
                                            : ''
                                    }
                                />
                            </Form.Item>
                            <Form.Item label="Venue">
                                <Input readOnly value={team.venue} />
                            </Form.Item>
                            <Form.Item label="Club">
                                <Input readOnly value={team.club} />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={12}>
                        <Form {...formItemLayout724}>
                            <Form.Item label="Category">
                                <Input readOnly value={team.category} />
                            </Form.Item>
                            <Form.Item label="Address">
                                <Input readOnly value={team.address} />
                            </Form.Item>
                            <Form.Item label="Phone">
                                <Input readOnly value={team.phone} />
                            </Form.Item>
                            <Form.Item label="Web">
                                <Input readOnly value={team.web} />
                            </Form.Item>
                            <Form.Item label="Email">
                                <Input readOnly value={team.email} />
                            </Form.Item>
                            <Form.Item label="Facebook ">
                                <Input readOnly value={team.facebook} />
                            </Form.Item>
                            <Form.Item label="Twitter ">
                                <Input readOnly value={team.twitter} />
                            </Form.Item>
                            <Form.Item label="Instagram">
                                <Input readOnly value={team.instagram} />
                            </Form.Item>
                            <Form.Item label="Youtube ">
                                <Input readOnly value={team.youtube} />
                            </Form.Item>
                            <Form.Item label="Professional">
                                <Checkbox checked={team.isPro} disabled />
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <Drawer
                    title="Edit team"
                    visible={drawerState === DrawerState.Edit}
                    onClose={(): void =>
                        this.handleDrawerMode(DrawerState.Read, team.id.toString())
                    }
                    width={DrawerWidth}
                    destroyOnClose
                >
                    <TeamForm
                        handleClose={this.handleDrawerMode}
                        refreshAfterSave={refreshAfterSave}
                        team={team}
                    />
                </Drawer>
            </div>
        );
    }
}

export default TeamDetails;
